"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useMatomo;
var _react = require("react");
var _MatomoContext = _interopRequireDefault(require("../context/MatomoContext"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function useMatomo() {
  const instance = (0, _react.useContext)(_MatomoContext.default);
  const trackPageView = (0, _react.useCallback)(params => instance === null || instance === void 0 ? void 0 : instance.trackPageView(params), [instance]);
  const trackEvent = (0, _react.useCallback)(params => instance === null || instance === void 0 ? void 0 : instance.trackEvent(params), [instance]);
  return {
    trackPageView,
    trackEvent
  };
}